module.exports = __webpack_public_path__ + "static/media/dk3kim.0ab85b31.png";